import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPalmDollar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		clipPath: "url(#palm-dollar-clip)",
		children: [/* @__PURE__ */ _jsx("path", { d: "M10 1V0H8v1.034c-1.148.192-2 1.18-2 2.37a2.41 2.41 0 0 0 1.84 2.332l1.894.468c.182.045.31.207.31.392A.406.406 0 0 1 9.635 7h-3.13v2H8v1h2V8.966c2.532-.423 2.706-4.088.225-4.702L8.33 3.796a.405.405 0 0 1-.31-.392c0-.223.184-.404.41-.404h3.129V1z" }), /* @__PURE__ */ _jsx("path", { d: "m2 8-2 4v4h8l8-5-.185-.296a2 2 0 0 0-2.764-.631L10 12H4v-2a2 2 0 0 0-2-2" })]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "palm-dollar-clip",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgPalmDollar;
